import { db } from "./firebase";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  collection,
  onSnapshot,
  query,
  addDoc,
  doc,
  deleteDoc
} from "firebase/firestore";
import React from "react";
import { Container, Row, Col, Form, Button, Accordion } from "react-bootstrap";
import { langs } from "./Common";

function Conditions() {
  const [conditions, setConditions] = useState([]);
  const [name, setName] = useState("");
  const [lang, setLang] = useState(langs[0].id);

  const q = query(collection(db, "conditions"));
  function adatLetolt() {
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const newData = [];
      querySnapshot.forEach((doc) => {
        newData.push({ id: doc.id, ...doc.data() });
      });
      var sortedArray = [...newData].sort(
        function (a, b) {
          const nameA = a.names.find((x) => x.id === lang).name.toUpperCase();
          const nameB = b.names.find((x) => x.id === lang).name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        }
      ); // names must be equal
      setConditions([...sortedArray]);
    });
    return unsubscribe;
  }

  useEffect(() => adatLetolt(), []);

  function handleAddCondition(event) {
    event.preventDefault();
    const dbRef = collection(db, "conditions");
    addDoc(dbRef, {
      names: [
        {
          id: lang,
          name: name
        }
      ]
    })
      .then((docRef) => {
        console.log(docRef.id); //p4eZcO5QV43IYnigxALJ
      })
      .catch((error) => {
        console.log(error);
      });
    setName("");
  }

  function handleDeleteCondition(event, condId) {
    event.preventDefault();
    if (window.confirm("Biztosan törlöd a lemondási feltételt?")) {
      const docRef = doc(db, "conditions", condId);
      deleteDoc(docRef)
        .then((docRef) => {
          console.log("Document deleted");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  return (
    <div className="Conditions">
      <Container className="pt-4">
        <Form>
          <Row>
            <Col className="text-start align-middle">
              <Form.Label htmlFor="inputTitle">
                Új feltétel létrehozása
              </Form.Label>
            </Col>
          </Row>
          <Row className="pt-2 pb-2">
            <Col className="text-start align-middle">
              <Form.Control
                id="condition"
                onChange={(e) => setName(e.target.value)}
              />
            </Col>
            <Col>
              <Button onClick={handleAddCondition} variant="primary" type="submit">
                Hozzáad
              </Button>
            </Col>
          </Row>
        </Form>
        {conditions &&
          conditions.map((p, i) => (
            <Row key={i} className="pt-2 pb-2 border-secondary border-bottom">
              <Col className="d-flex justify-content-start align-items-center">
                <Link
                  to="/condition"
                  state={{ gId: p.id }}
                  style={{ textDecoration: "none", color: "#000" }}
                >
                  {p.hasOwnProperty("names") &&
                  p.names.find((l) => l.id === lang) &&
                  p.names.find((l) => l.id === lang).hasOwnProperty("name")
                    ? p.names.find((l) => l.id === lang).name
                    : ""}
                </Link>
              </Col>
              <Col>
                <Button
                  onClick={(event) => handleDeleteCondition(event, p.id)}
                  variant="primary"
                  type="submit"
                >
                  Törlés
                </Button>
              </Col>
            </Row>
          ))}
      </Container>
    </div>
  );
}

export default Conditions;
